import React from "react";
import { createStyles } from "@mantine/core";
import { tokens } from "@blurb/codex-react";
import { flexColumn } from "./shared";

const useStyles = createStyles(() => ({
  card: {
    ...flexColumn,
    flex: "1 0 0",
    minWidth: 280,
    maxWidth: "50%",
    gap: tokens.spacing[6],
    padding: tokens.spacing[4],
    backgroundColor: tokens.color.primitive.light.gray[50],
    borderRadius: tokens.radius.sm,
  },
  section: {
    ...flexColumn,
    gap: tokens.spacing[1],
  },
}));

export const OrderDetailCard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { classes } = useStyles();
  return <div className={classes.card}>{children}</div>;
};

export const CardSection: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { classes } = useStyles();
  return <div className={classes.section}>{children}</div>;
};
